import { FC, SetStateAction, useState, useEffect, Dispatch } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import FeedbackAccordionBadge from "./FeedbackAccordionBadge";
import { FeedbackType } from "@/utils/types";

interface Props {
  feedback: FeedbackType;
  isExpanded: boolean | undefined;
  setIsExpanded: Dispatch<SetStateAction<boolean | undefined>>;
  clickFlag: boolean;
  setClickFlag: Dispatch<SetStateAction<boolean>>;
}

const FeedbackAccordion: FC<Props> = ({
  feedback,
  isExpanded,
  setIsExpanded,
  clickFlag,
  setClickFlag,
}) => {
  const [firstLoad, setFirstLoad] = useState(false);
  const [accordionValue, setAccordionValue] = useState(["item-0"]);

  useEffect(() => {
    if (isExpanded === undefined && !firstLoad) {
      setFirstLoad(true);
      return;
    }
    if (clickFlag) {
      setClickFlag(false);
      return;
    }
    setAccordionValue(isExpanded ? feedback.map((_, i) => `item-${i}`) : []);
  }, [isExpanded]);

  useEffect(() => {
    if (isExpanded === undefined) return;
    setIsExpanded(() => accordionValue.length === feedback.length);
  }, [accordionValue]);

  const handleClick = (value: string) => {
    setAccordionValue((val) => {
      const idx = val.findIndex((v) => v === value);
      if (idx === -1) return [...val, value];
      return val.filter((v) => v !== value);
    });
    setClickFlag(true);
  };
  feedback.forEach((feed, index) => {
  });
  

  return (
    <Accordion type="multiple" value={accordionValue}>
      {feedback.length == 0 && <p>There is no feedback to show. Please answer the interview question to get feedback.</p>}
      {feedback.map((feed, index) => (
        <AccordionItem value={`item-${index}`} key={index}>
          <AccordionTrigger
            className="text-black my-[32px] mx-0 p-0 hover:no-underline py-[32px]"
            onClick={() => handleClick(`item-${index}`)}
          >
            <div className="flex gap-4 p-0 m-0">
              <span className="font-bold text-lg">{feed.title}</span>
              <FeedbackAccordionBadge badgeType={feed.badgeType} />
            </div>
          </AccordionTrigger>
          <AccordionContent className="text-left p-0 m-0 pb-4 font-normal">
            {feed.desc.split("<br/>").map((d, i) => (d.trim() === "" ? <br key={i}/> :
              <p key={i}>{d.trim()}</p>
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FeedbackAccordion;
